import script from "./VideoItemStatusV2.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoItemStatusV2.vue?vue&type=script&lang=ts&setup=true"

import "./VideoItemStatusV2.vue?vue&type=style&index=0&id=bfed2424&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfed2424"]])

export default __exports__